import React from "react";

export default function Base({}) {
	return <g transform={`translate(0, 10)`}>
		<path d="M73.6769 22.264L55.0179 81.329L100.107 22.264H73.6769Z"/>
		<path d="M14.528 1.36499L0.209961 18.554H24.57L14.528 1.36499Z"/>
		<path d="M85.575 1.36499L75.566 18.554H99.9261L85.575 1.36499Z"/>
		<path d="M26.432 22.264H0L45.089 81.329L26.432 22.264Z"/>
		<path d="M54.533 0L71.933 17.4L82.081 0H54.533Z"/>
		<path d="M18.033 0L28.181 17.4L45.581 0H18.033Z"/>
		<path d="M30.3199 22.264L50.0549 84.749L69.7899 22.264H30.3199Z"/>
		<path d="M50.0551 0.767944L32.269 18.5539H67.841L50.0551 0.767944Z"/>
	</g>
}